<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <div class="inputkuang">
      <template v-for="item in settingDetail">
        <template v-if="item.display && item.fieldCaption != null">
          <dl
            :class="{
              chbox:
                item.editorType == 2 ||
                item.editorType == 5 ||
                item.editorType == 4,
            }"
            :key="item.id"
          >
            <dt :class="{ fieldLabelRequired: !item.nullable }">
              {{ item.fieldCaption }} <sup v-if="item.nullable == 0">*</sup>
            </dt>
            <dd v-if="item.editorType == 1">
              <!-- 单行文本框 -->
              <van-field
                class="input-item"
                v-model="formData[item.field]"
                :maxlength="item.fieldLength"
                clearable
                :placeholder="'请输入' + item.fieldCaption"
              />
            </dd>
            <dd v-if="item.editorType == 7">
              <van-field
                class="input-item"
                v-model="formData[item.field]"
                :maxlength="item.fieldLength"
                type="textarea"
                clearable
                :placeholder="'请输入' + item.fieldCaption"
              />
            </dd>
            <!-- 单选下拉框 -->
            <dd v-if="item.editorType == 4">
              <van-cell
                class="input-item"
                :value="
                  getDisplayValue(formData[item.field], item)
                    ? getDisplayValue(formData[item.field], item)
                    : '请选择' + item.fieldCaption
                "
                is-link
                @click="showPicker(item, undefined)"
              />
            </dd>
            <!-- 单选下拉框 -->
            <dd v-if="item.editorType == 5">
              <van-cell
                class="input-item"
                :value="
                  getDisplayValue(formData[item.field], item)
                    ? getDisplayValue(formData[item.field], item)
                    : '请选择' + item.fieldCaption
                "
                is-link
                @click="showPicker(item, undefined)"
              />
            </dd>
            <!-- 日期选择框 -->
            <dd v-if="item.editorType == 3">
              <van-cell
                class="input-item dateItem"
                style=""
                :value="
                  dateFormatString(formData[item.field])
                    ? dateFormatString(formData[item.field])
                    : '请选择' + item.fieldCaption
                "
                is-link
                @click="showDatePicker(undefined, item)"
              >
                <template #right-icon>
                  <van-icon name="notes-o" />
                </template>
              </van-cell>
            </dd>
          </dl>
        </template>
      </template>
      <!-- 选择弹窗 -->
      <van-popup v-model="selectModel" position="bottom">
        <van-datetime-picker
          v-if="dateField"
          :value="dateField.value"
          type="date"
          @cancel="onCancel"
          @confirm="onConfirmDate"
        />
        <van-picker
          v-else
          show-toolbar
          ref="picker"
          :value-key="key"
          :columns="columns"
          @change="onChange"
          @cancel="onCancel"
          @confirm="onConfirm"
        />
      </van-popup>
    </div>
    <div class="inputkuang" style="margin-bottom:0px">
      <van-divider>参会信息</van-divider>
      <dl class="chbox">
        <dt>选择分会场 <sup>*</sup></dt>
        <van-cell
          class="input-item"
          :value="formDataVal ? formDataVal : '请选择分会场'"
          is-link
          @click="showPickerFc(formDataVal, undefined)"
        />
      </dl>
      <van-button type="primary" size="large" @click="next">确定</van-button>
    </div>
    <van-popup v-model="selectModelFc" position="bottom">
      <van-picker
        show-toolbar 
        ref="picker"
        :value-key="key"
        :columns="columnsFc"
        @cancel="onCancelFc"
        @confirm="onConfirmFc"
      />
    </van-popup>
  </div>
</template>
<script type="text/javascript">
import vHead from "@/components/Subhead.vue";

import { mapState, mapMutations, mapGetters } from "vuex";
import {
  Uploader,
  Toast,
  Field,
  Button,
  DatetimePicker,
  Popup,
  Picker,
  Cell,
  CellGroup,
  Divider,
} from "vant";
import {
  getMeetingDetail,
  getMeetingSettings,
  getDictionary,
  getHotelsDues,
  getUser,
  groupMeetingRegisterMember
} from "@/api/dictionary";
export default {
  data() {
    return {
      title: "添加参会人员",
      settingDetail: {},
      formData: {},
      pickerField: undefined, // 弹窗选择对应的字段
      dateField: undefined, // 弹窗日期选择的字段,
      selectModel: false,
      selectModelFc: false,
      columns: [],
      columnsFc: [],
      discountPrice: "",
      originalPrice: "",
      allDictionary: [],
      formDataVal: "",
      userInfo: {},
      key: "name", //选择弹窗显示对应的参数名
    };
  },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Divider.name]: Divider,
  },
  methods: {
    ...mapMutations(["setAddrList"]),
    getMeeting() {
      if (this.id) {
        getMeetingDetail({ meetingId: this.id }).then((res) => {
          this.columnsFc = res.result.meetingPlaceDTOs;
        });
      }
    },
    showPickerFc() {
      this.selectModelFc = true;
      this.getMeeting();
    },
    onConfirmFc(value) {
      this.formDataVal = value.name;
      this.selectModelFc = false;
      this.placeId = value.id;
    },
    next() {
        let params = Object.assign(this.formData);
        params.meetingId = this.id;
        params.memberId = this.userInfo.id;
        if(!this.formData.name){
          Toast.fail("姓名不能为空")
          return;
        }
        if(!this.formData.mobile){
          Toast.fail("手机号不能为空")
          return;
        }
        if(!this.formData.company){
          Toast.fail("工作单位不能为空")
          return;
        }
        if(!this.formData.gender){
          Toast.fail("请选择您的性别")
          return;
        }
        if(!this.formData.isStudent){
          Toast.fail("请选择是否")
          return;
        }
        groupMeetingRegisterMember(params).then(res=>{
            this.$router.push({ name: "signUpPage", query: { meetingId: this.id,placeId:this.placeId}});
            Toast.success('添加成功');
        })
        console.log(params)
    },
    onCancelFc() {
      this.selectModelFc = false;
    },
    getDisplayValue(value, field) {
      var optionsData = this.fieldDictionary(field.dictionaryId);
      var currentItem = optionsData.find((item) => item.value === value);
      return currentItem ? currentItem.name : "";
    },
    onChange(picker, values, index) {
      if (this.selectKey === "title") {
        picker.setColumnValues(1, values[0].children);
      } else if (this.selectKey === "jg" || this.selectKey === "province") {
        let city = this.allAddress.filter((item) => {
          return item.parentId === values[0].id;
        });
        if (index === 0) {
          picker.setColumnValues(1, city);
        }
      }
    },
    showPicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.columns = this.fieldDictionary(pickerField.dictionaryId);
      this.selectModel = true;
    },
    onCancel() {
      this.selectModel = false;
    },
    onConfirm(item) {
      this.selectModel = false;
      var fieldVal;
      this.formData[this.pickerField.field] = fieldVal = item.value;
      this.pickerField.value = fieldVal;
      this.pickerField.displayValue = item.name;
      this.pickerField = undefined;
      this.selectKey = undefined;
    },
    fieldDictionary(code) {
      return this.allDictionary.filter((item) => item.dictCode == code);
    },
    getUserInfo() {
      getUser().then((res) => {
        if (res.success) {
          this.userInfo = res.result;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["searchAdd", "getCityList"]),
    id() {
      return this.$route.query && this.$route.query.meetingId;
    },
  },
  mounted() {
    this.getUserInfo();
    console.log(this.userInfo);
    getMeetingSettings({ meetingId: this.id })
      .then((resp) => {
        if (resp.success) {
          this.settingDetail = resp.result;
        }
      })
      .catch(() => {
        this.$message.error("获取报名设置失败！");
      });
    getDictionary().then((res) => {
      if (res.success) {
        this.allDictionary = res.result;
      }
    });
  },
};
</script>

<style lang="less" scoped>
.inputkuang {
  margin-top: 25px;
  margin-bottom: -35px;
}
.meetingFont {
  font-size: 16px;
  line-height: 32px;
  margin-top: 20px;
  padding: 0 15px;
  padding-bottom: 20px;
}
.attendance button {
  border-left: none;
  border-right: none;
  border-top: 5px solid #eef2f5;
  border-bottom: 5px solid #eef2f5;
  border-radius: initial;
  padding: 25px 0;
}
</style>